<template>
  <FormGroup :title="label">
    <Dropdown :primary="primary && !simple" :success="success" fill :value="simple ? (localValue && localValue.name) : (selectedUser && selectedUser.name)" :items="usersForDropdown" @change="handleChange">
      <span v-if="simple && localValue">{{ localValue.name }}</span>
      <span v-else-if="selectedUser">{{ selectedUser.name }}</span>
      <span v-else>{{ $t('Kies gezinslid') }}</span>
    </Dropdown>
  </FormGroup>
</template>

<script>
import Dropdown from './Dropdown'
import FormGroup from './FormGroup'
export default {
  name: 'UserSelect',
  components: {
    FormGroup,
    Dropdown
  },
  props: {
    required: {
      default: true,
      type: Boolean
    },
    label: String,
    success: Boolean,
    primary: {
      type: Boolean,
      default: true
    },
    simple: Boolean
  },
  data () {
    return {
      localValue: null
    }
  },
  computed: {
    selectedUser () {
      return this.$store.getters['user/selectedUser']
    },
    users () {
      return this.$store.getters['user/users']
    },
    usersForDropdown () {
      const values = this.users.map(user => {
        return { key: user.uid, value: user.name }
      })
      if (!this.required) {
        values.unshift({
          key: false, value: 'Alle gebruikers'
        })
      }
      return values
    }
  },
  methods: {
    handleChange (uid) {
      if (this.simple) {
        this.$emit('input', uid)
      } else {
        this.$store.commit('user/setSelectedUser', uid)
      }
    }
  }
}
</script>
